import React, { useState, useEffect } from 'react';

const Autocomtyp = () => {

    const strings = ["Branch Banking", "Risk Management", "Remedial & Structured Credits", "Global Operations"];
    const [currentStringIndex, setCurrentStringIndex] = useState(0);
    const [currentText, setCurrentText] = useState('');
    const [isTyping, setIsTyping] = useState(true);
  
    const typingSpeed = 100;
    const deleteSpeed = 40;
    const isLoop = true;
    const isPlaceholder = true;
  
    //-------------------------

    useEffect(() => {
        const typing = () => {
          if (isPlaceholder) {
            // Handle placeholder typing effect
            // Update your input field's placeholder
            // Example: document.getElementById("yourInputId").placeholder = strings[currentStringIndex].substring(0, currentText.length);
            document.getElementById("auto").placeholder = strings[currentStringIndex].substring(0, currentText.length);
          } else {
            // Handle innerHTML typing effect
            // Update the content of your element
            // Example: document.getElementById("yourElementId").innerHTML = strings[currentStringIndex].substring(0, currentText.length);
            document.getElementById("auto").placeholder = strings[currentStringIndex].substring(0, currentText.length);
          }
    
          if (currentText.length === strings[currentStringIndex].length) {
            setTimeout(() => {
              setIsTyping(false);
              setCurrentText('');
    
              if (isLoop || currentStringIndex < strings.length - 1) {
                setTimeout(() => {
                  setIsTyping(true);
                  setCurrentStringIndex((prevIndex) => (prevIndex + 1) % strings.length);
                }, deleteSpeed);
              }
            }, typingSpeed);
          } else {
            setTimeout(() => {
              setCurrentText((prevText) => strings[currentStringIndex].substring(0, prevText.length + 1));
            }, typingSpeed);
          }
        };
    
        if (isTyping) {
          typing();
        }
      }, [currentText, currentStringIndex, isLoop, isPlaceholder, isTyping]);
//------------------

const suggestions = [
    { label: "Apple", url: "https://example.com/apple" },
    { label: "Banana", url: "https://example.com/banana" },
    { label: "Cherry", url: "https://example.com/cherry" },
    { label: "Date", url: "https://example.com/date" },
    { label: "Fig", url: "https://example.com/fig" },
  ];

  const [inputValue, setInputValue] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Filter suggestions based on user input
    const filtered = suggestions.filter(suggestion =>
      suggestion.label.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredSuggestions(filtered);
  };

  const handleSuggestionClick = (suggestion) => {
    // Set the selected suggestion and clear the input
    setSelectedSuggestion(suggestion);
    setInputValue('');
  };

  const handleButtonClick = () => {
    // Handle button click, for example, navigate to the selected URL
    if (selectedSuggestion) {
      window.location.href = selectedSuggestion.url;
    }
  };

  return (
    <div>

{/* <input
        type="text"
        id="auto"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Type to search..."
      /> */}
      <div class="sform">
        <input type="text" id="auto" placeholder="" value={inputValue} class="sfield" onChange={handleInputChange} />
        <p id="outputcontent">
          <a class="cust-but" onClick={handleButtonClick}>Click</a>
        </p>
      </div>
       {filteredSuggestions.length > 0 && (
        <ul>
          {filteredSuggestions.map((suggestion, index) => (
            <li key={index} onClick={() => handleSuggestionClick(suggestion)}>
              {suggestion.label}
            </li>
          ))}
        </ul>
      )}

      {selectedSuggestion && (
        <div>
        {/* <p>Selected: {selectedSuggestion.label}</p> */}
          <button onClick={handleButtonClick}>Go to {selectedSuggestion.label}</button>
        </div>
      )}
    </div>
  )
}

export default Autocomtyp
